import { Component, inject, Input, OnInit } from '@angular/core';
import { ApiOfferSet, OfferSetsApi } from 'api';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-membership-pog-bar',
  templateUrl: './membership-pog-bar.component.html',
  styleUrls: ['./membership-pog-bar.component.scss']
})
export class MembershipPogBarComponent implements OnInit {
  private offerSetApi = inject(OfferSetsApi);
  private route = inject(ActivatedRoute);

  @Input() offerSet: ApiOfferSet;
  async ngOnInit() {
    if (!this.offerSet) {
      const offerSetId = this.route.snapshot.queryParamMap.get('offerSetId');
      const defaultParam = this.route.snapshot.queryParamMap.get('default');
      const defaultParamBool = defaultParam === 'true';
      this.offerSet = await this.offerSetApi.get(offerSetId, defaultParamBool).toPromise();
    }
  }

  ratio() {
    if (!this.offerSet) return 0;
    return Math.min(this.offerSet.membership_goal_current_value / this.offerSet.membership_goal, 1);
  }
}
